import React from 'react';
import { ThemeSwitcher } from '../../theme/ThemeProvider';
const asset = name => `${process.env.PUBLIC_URL}/branding/${name}`;

export function AuthHeader({ burgerbot = false }) {
    return <header className="auth-header"><div className="auth-brand">
        {burgerbot ? <span className="auth-burgerbot-mark"><img src={asset('burgerbot-logo.svg')} alt="" /></span>
            : <span className="auth-standard-mark"><img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="" /></span>}
        <span>{burgerbot ? 'BurgerBot' : 'IT-Burger'}</span>
    </div><ThemeSwitcher /></header>;
}
export function AuthArtwork() {
    return <div className="auth-artwork" aria-hidden="true"><div className="auth-art-scene"><img className="auth-art-base" src={asset('burgers-base.png')} alt="" /><img className="auth-art-glass" src={asset('burgers-glass.png')} alt="" /><div className="auth-art-tint" /></div></div>;
}
